import { CategoriesNavController } from './categories-nav.controller';

export const CategoriesNavComponent: ng.IComponentOptions = {
  bindings: {
    categories: '<',
  },
  templateUrl: 'categories/components/categories-nav/categories-nav.html',
  controller: CategoriesNavController,
};
